import type { ProductType } from '@/AppGlobal';
import { BankTypeEnum } from './withdrawal';

export type BankInfoCardType = {
  bankCardName?: string; //	银行卡名
  bankCardEnName?: BankTypeEnum; // 银行卡 枚举值名
  bankCardNum1?: string; //	银行卡号
};

export enum BankCardTagType {
  DEFAULT, // 有产品使用
  HANDLING, // 处理中
  UNBINGDING, // 解绑中
  NotDefault, // 不默认
}

export enum DefaultType {
  Default = 'Y',
  NotDefault = 'N',
}

// 1 初始化成功  2 初始化失败  3  初始化处理中  4 解绑处理中 5 解绑失败  6解绑成功
export enum BankEddState {
  BindSuccess = '1',
  BindFail = '2',
  BindHandling = '3',
  Unbinding = '4',
  UnbindFail = '5',
  UnbindSuccess = '6',
  Pending = '7', // 外部系統等待中
}

export enum EddaUpdateType {
  AddEdda = '1', // 新增 Edda
  RemoveEdda = '2', // 解绑 Edda
}

export type EddaBankInfo = Partial<{
  state: BankEddState; // 状态
  bankCardCode: string; // 卡ID
  bankCardName: string; // 卡名
  bankCardNumShow: string; // 页面展示银行卡号
  bankCardNumEncrypt: string; // 加密的银行卡号
  isDefault: DefaultType; // 是否默认卡
  amt: number; // 还款金额
  repaymentTime: string; // 最近还款日期
  bankCardEnName: BankTypeEnum; // 英文名
  id: string;
  msgId?: string;
  bankEnNameAbbr: BankTypeEnum;
  mandateId?: string;
  defaultmesgId?: string;
  productList?: { productCode: ProductType }[];
}>;
